if (!customElements.get('product-submit')) {
  class ProductSubmit extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);

      this.handleVariantChangeRef = this.handleVariantChange.bind(this);

      this.handlePersonalizationEnabledRef = this.handlePersonalizationEnabled.bind(this);
      this.handlePersonalizationChangeRef = this.handlePersonalizationChange.bind(this);

      this.handleUpsellAddRef = this.handleUpsellAdd.bind(this);
      this.handleUpsellRemoveRef = this.handleUpsellRemove.bind(this);

      this.handleRecipientChangeRef = this.handleRecipientChange.bind(this);
    }

    handleUpsellAdd(event) {
      if (!this.upsells.some(item => item.id === event.detail.item.id)) {
        this.upsells.push(event.detail.item);
      }

      this.handleClick();
    }

    handleUpsellRemove(event) {
      this.upsells = this.upsells.filter(item => item.id != event.detail.item.id);
    }

    async getCartAddItems() {
      const items = [];
      const formData = new FormData(this.button.form);
      const quantity = formData.get('quantity');
      const personalizationField = this.button.form.querySelector('.product-personalization--additional-products .js-personalization-field');

      // Main Product
      const baseProduct = {
        id: formData.get('id'),
        quantity,
        properties: {}
      };

      for (const [key, value] of formData) {
        if (key.includes('properties')) {
          baseProduct['properties'][`${key.split('[')[1].split(']')[0]}`] = value;
        }
      }

      if (this.upsells.length) baseProduct.properties['_upsells'] = [];

      // Charms
      this.upsells.forEach(item => {
        baseProduct.properties._upsells.push(item.id);
        items.push({...item, quantity});
      });

      // Letters
      if (personalizationField) {
        let itemTime = new Date().getTime();
        const inputString = personalizationField.value;
        const inputStringArray = inputString.split('');
        const lettersArray = personalizationField.dataset.letters.split(',');

        lettersArray.forEach(letterItem => {
          const letterItemName = letterItem.split('|')[0];
          const letterItemId = letterItem.split('|')[1];

          if (personalizationField.closest('.product-personalization').classList.contains('inexpensive')) {
            let namesArray = personalizationField.dataset.special.split(',');

            if (namesArray.indexOf(letterItemName) !== -1) {
              let specialJson = {
                quantity: 1,
                id: letterItemId,
                properties: {
                  letters: personalizationField.value,
                  _isBundle: true,
                  _bundleID: itemTime,
                  _bundleChild: true
                }
              }
              // Add personalization (typically a letter product) to items array
              items.push(specialJson);
            };
          };
        });

        inputStringArray.forEach(inputLetter => {
          lettersArray.forEach(letterItem => {
            const letterItemName = letterItem.split('|')[0]
            const letterItemId = letterItem.split('|')[1]

            if (inputLetter == letterItemName ) {
              var itemJson = {
                quantity: 1,
                id: letterItemId,
                properties: {
                  letters: personalizationField.value,
                  _isBundle: true,
                  _bundleID: itemTime,
                  _bundleChild: true
                }
              }

              items.push(itemJson);
            };
          })
        });

        baseProduct.properties['letters'] = personalizationField.value;
        baseProduct.properties['_isBundle'] = true;
        baseProduct.properties['_bundleID'] = itemTime;
        baseProduct.properties['_bundleParent'] = true;
      }

      // Push Main Product to items array
      items.push(baseProduct);

      // Remove main product and its charms/letters when re-adding the main product and its addons
      if (this.upsells.length){
        await this.removeProductsFromCart(items);
      }

      return { items };
    }

    removeProductsFromCart(itemsToRemove) {
      return fetch(`${window.routes.cart_url}.js`, { method: 'GET' })
      .then(response => response.json())
      .then((cart) => {

        let updates = {}
        for(const item of itemsToRemove){
          const idToRemove = parseInt(item.id);
          const itemToRemove = cart.items.filter((item) =>
            item.variant_id == idToRemove
          );
          if(!!itemToRemove.length) updates[itemToRemove[0].key] = 0
        }

        if(!Object.keys(updates).length) return false

        return fetch(`${window.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            'updates': updates
          })
        })
        .then(response => response.json())
        .then(() => {
          return true
        })
      })
      .catch((error) => {
        console.error(error);
      });
    }

    async handleClick(event) {
      event?.preventDefault();

      if (this.canSubmit) {
        this.setEngravingErrorText(true);

        addToCart(await this.getCartAddItems());
      } else {
        if (this.errorElement.textContent.length === 0) {
          this.setEngravingErrorText(false);
        }
      }
    }

    handlePersonalizationEnabled() {
      this.canSubmit = false;

      this.errorElement = document.createElement('p');
      this.errorElement.classList.add('product__error');

      this.prepend(this.errorElement);
    }

    setEngravingErrorText(force, message) {
      if (!this.errorElement) return;
      this.errorElement.innerHTML = force ? '' : message ? message : this.getAttribute('data-engraving-error');
    }

    handlePersonalizationChange(event) {
      this.canSubmit = event.detail.valid;

      this.setEngravingErrorText(event.detail.valid, event.detail.error);
    }

    enable() {
      this.button.classList.remove('hidden');
      this.notifyButton?.classList.add('hidden');
      if (this.button.dataset.addToBag) this.button.textContent = this.button.dataset.addToBag;
    }

    disable() {
      this.button.classList.add('hidden');
      this.notifyButton?.classList.remove('hidden');
    }

    getSelectedOption() {
      const form = this.closest('form');
      if (!form) return null;
      const select = form.querySelector('product-select select');
      return select ? select.querySelector('option:checked') : null;
    }

    applyStateFromOption(option) {
      if (!option || option.hasAttribute('disabled')) return this.disable();

      this.button.classList.remove('hidden');
      this.button.textContent = option.dataset.atcText || this.button.dataset.addToBag;

      if (option.dataset.showNotify === 'true') {
        this.notifyButton?.classList.remove('hidden');
      } else {
        this.notifyButton?.classList.add('hidden');
      }
    }

    handleVariantChange(event) {
      if (event.detail.productId != this.getAttribute('data-product-id') || !event.detail.option) return;

      this.applyStateFromOption(event.detail.option);
    }

    handleRecipientChange(event) {
      return event.detail.isMatching ? this.enable() : this.disable();
    }

    disconnectedCallback() {
      this.errorElement = null;

      document.removeEventListener('alexa:variant-change', this.handleVariantChangeRef);
      document.removeEventListener('alexa:personalization-enabled', this.handlePersonalizationEnabledRef);
      document.removeEventListener('alexa:personalization-change', this.handlePersonalizationChangeRef);

      if (!this.hasAttribute('data-await-recipient')) return;
      document.removeEventListener('alexa:compare-recipient:change', this.handleRecipientChangeRef);
    }

    connectedCallback() {
      this.canSubmit = true;
      this.button = this.querySelector('button');
      this.notifyButton = this.querySelector('.js-klaviyo-notify-trigger');

      if (!this.button) return;

      this.button.addEventListener('click', this.handleClickRef);

      this.upsells = [];

      document.addEventListener('alexa:variant-change', this.handleVariantChangeRef);

      document.addEventListener('alexa:personalization-enabled', this.handlePersonalizationEnabledRef);
      document.addEventListener('alexa:personalization-change', this.handlePersonalizationChangeRef);

      document.addEventListener('alexa:upsell-add', this.handleUpsellAddRef);
      document.addEventListener('alexa:upsell-remove', this.handleUpsellRemoveRef);

      if (this.hasAttribute('data-await-recipient')) {
        document.addEventListener('alexa:compare-recipient:change', this.handleRecipientChangeRef);
        this.disable();
      } else {
        this.applyStateFromOption(this.getSelectedOption());
      }
    }
  }

  customElements.define('product-submit', ProductSubmit);
}
